import * as React from "react"
import type { Profile } from "../../profile.ts"

export const AudioPlayerContext = React.createContext<AudioPlayerContext | null>(null)

export interface AudioPlayerContext {
  currentTrack: CurrentTrack | null
  currentTrackTime: number
  isPlaying: boolean
  playTrack: (trackId: string, playlist: Profile.Playlist) => void
  playPlaylist: (playlist: Profile.Playlist) => void
  playNextTrack: () => void
  playPreviousTrack: () => void
  togglePlayPause: () => void
  setCurrentTrackTime: (time: number) => void
}

export interface CurrentTrack {
  id: string
  title: string
  artist: string
  duration: number
  index: number
  playlist: {
    id: string
    coverImageUrl: string
  }
}

export interface CurrentPlaylist {
  id: string
  coverImageUrl: string
  tracks: Array<Profile.ReleasedTrack>
}
